import React from "react";
import "./styles.scss";

interface State {
  portraits: HTMLImageElement[];
}

export class Cover extends React.Component<State> {
  constructor(props) {
    super(props);

    this.state = {
      portraits: []
    };

    this.movePortraits = this.movePortraits.bind(this);
  }

  movePortraits() {
    this.state.portraits.map(p => {
      p.node.style.transform =
        "translateY(-" + window.pageYOffset * 5 * p.speed + "px)";
    });
  }

  componentDidMount() {
    const portraits = [...document.getElementsByClassName("header-portrait")];
    const portraitsObj = portraits.reduce((prev, curr) => {
      return [
        ...prev,
        ...[
          {
            node: curr,
            speed: Math.random()
          }
        ]
      ];
    }, []);

    console.log(portraitsObj);

    window.addEventListener("scroll", this.movePortraits);
    this.setState({
      portraits: portraitsObj
    });
  }

  render() {
    return (
      <header className="ui vertical very relaxed segment">
        <div className="ui container">
          <h1 className="ui header">
            <img
              className="header-portrait portrait-d"
              src={require("../../images/portraits/bw/portrait-8.png")}
            />
            <img
              className="header-portrait portrait-a"
              src={require("../../images/portraits/bw/portrait-12.png")}
            />
            <img
              className="header-portrait portrait-f"
              src={require("../../images/portraits/bw/portrait-13.png")}
            />
            <div className="content">
              Quelle musique écoutent le plus les Romands?{" "}
              <div className="sub header">
                Voici les goûts musicaux 2019 en 20 cartes détaillées. Le
                reggaeton, le rap français et la pop se taillent la part du
                lion. Séance de rattrapage musical.
              </div>
              <p className="ta author">
                <strong>
                  Duc-Quang Nguyen, Christophe Passer, Mathieu Rudaz
                </strong>
              </p>
            </div>
            <img
              className="header-portrait portrait-b"
              src={require("../../images/portraits/bw/portrait-5.png")}
            />
            <img
              className="header-portrait portrait-c"
              src={require("../../images/portraits/bw/portrait-7.png")}
            />
            <img
              className="header-portrait portrait-e"
              src={require("../../images/portraits/bw/portrait-9.png")}
            />
          </h1>
        </div>
        <div
          className="illustration-wrapper"
          style={{
            marginTop: "4em",
            backgroundImage: "url(" + require("./cover.png") + ")"
          }}
        />
      </header>
    );
  }
}
